import script from "./UiCount.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCount.vue?vue&type=script&setup=true&lang=js"

import "./UiCount.vue?vue&type=style&index=0&id=d2ed9b7e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2ed9b7e"]])

export default __exports__